import { render, staticRenderFns } from "./cFeatureTile.vue?vue&type=template&id=828166e6&scoped=true"
import script from "./cFeatureTile.vue?vue&type=script&lang=js"
export * from "./cFeatureTile.vue?vue&type=script&lang=js"
import style0 from "./cFeatureTile.vue?vue&type=style&index=0&id=828166e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828166e6",
  null
  
)

export default component.exports